module.exports = __webpack_public_path__ + "static/VSTT-aa6e478e4949f00e4ec4011230558a75.png";